
export { mapShipment } from "./shipment.mapper"